export enum TaxiCorporationListRequestOrder {
  COMPANY_NAME_ASC = "COMPANY_NAME_ASC",
  COMPANY_NAME_DESC = "COMPANY_NAME_DESC",
  DISPLAY_NAME_ASC = "DISPLAY_NAME_ASC",
  DISPLAY_NAME_DESC = "DISPLAY_NAME_DESC",
}

export type TaxiCorporationListRequestQueryParams = {
  taxId?: string;
  regon?: string;
  order?: TaxiCorporationListRequestOrder;
  krsNo?: string;
  companyName?: string;
  displayName?: string;
  headquartersAddressString?: string;
  notes?: string;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

type TaxiCorporationListRequest = {
  taxId?: string;
  regon?: string;
  order?: TaxiCorporationListRequestOrder;
  krsNo?: string;
  companyName?: string;
  displayName?: string;
  headquartersAddressString: string | undefined;
  notes?: string;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

export default TaxiCorporationListRequest;
